import _ from 'lodash'
import { connect } from 'react-redux'
import { FormFeedback } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { selectedBoosterPlan } from 'quick-quote/product-life-protect-plus/actions'
import { getBoosterSA } from 'quick-quote/product-life-protect-plus/selectors'
import VALUES from 'core/data-model/constants/values'

export const LifeProtectPlusSABooster = ({ boosterSA, onSelectBoosterPlan }) => {
  const lifeProtectPlusSABooster = [
    {
      text: 'Booster 50%',
      value: VALUES.BOOSTER_SA_PLAN.FIFTY_PERCENT,
    },
    {
      text: 'Booster 100%',
      value: VALUES.BOOSTER_SA_PLAN.ONE_HUNDRED_PERCENT,
    },
  ]

  return (
    <div>
      <div className="form-group">
        <div className="form-group-title">
          <span className="form-group-title-text">เลือกแผนความคุ้มครอง</span>
        </div>
        <RadioButtonGroup
          keyToGetValue="value"
          className="model-factor sa-booster-selection"
          onChange={onSelectBoosterPlan}
          value={boosterSA?.boosterPlan}
          options={lifeProtectPlusSABooster}
        />
        {boosterSA && (
          <FormFeedback className="info-message attached-icon">
            <p>{boosterSA.boosterMessage}</p>
            <p>{boosterSA.boosterRemark}</p>
          </FormFeedback>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  boosterSA: getBoosterSA(state),
})

const mapDispatchToProps = (dispatch) => ({
  onSelectBoosterPlan: bindActionCreators(selectedBoosterPlan, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(LifeProtectPlusSABooster)
